/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Tabs } from './Tabs'
import { Outlet } from 'react-router-dom-v5-compat'
import { ActionsBar } from './ActionsBar/ActionsBar'

const Products = () => {
    return (
      <>
          <div
            css={css`
                display: flex;
                align-items: center;
            `}
          >
              <Tabs />
              <div
                css={css`
                    margin-left: auto;
                `}
              >
                  <ActionsBar />
              </div>
          </div>
          <Outlet />
      </>
    )
}

export { Products }
